import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export function AnnouncementBar() {
  const messages = [
    { text: "New Market Education Series — Now Available", to: "/courses" },
    { text: "Daily Market Insights — Published Every Day", to: "/research" },
    { text: "Free Calculators — CPR Matrix, Pivot Points, PCR & OI Support/Resistance", to: "/calculators" },
    { text: "Now Available: 'Mastering Pivot Trading' & 'Systematic F&O Trading Framework'", to: "/#books" },
    { text: "Explore Our Structured Trading Frameworks", to: "/strategy" },
  ];
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % messages.length), 5000);
    return () => clearInterval(t);
  }, [messages.length]);

  return (
    <div className="bg-navy text-white text-center text-xs sm:text-[13px] py-2 px-4 grain" data-testid="announcement-bar">
      <span className="text-gold mr-2">◆</span>
      <Link to={messages[i].to} data-testid="announcement-link" className="tracking-wide hover:text-gold transition-colors">
        {messages[i].text}
      </Link>
    </div>
  );
}
